// MUI components
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const Chip = styled(Box)({
  color: 'rgba(0,0,0,0.87)',
  backgroundColor: 'rgba(0, 0, 0, 0.08)',
  height: 24,
  borderRadius: 16,
  fontSize: 12,
  fontWeight: 400,
  padding: '4px 6px',
  display: 'flex',
  alignItems: 'center',
  whiteSpace: 'pre',
  gap: '4px',
});
